<template>
    <div>
        <div id="section-to-print">
            <span class="fTop">ទទួលទំនិញពីអ្នកផ្គត់ផ្គង់</span>
            <v-row type="flex" class="row-bg fTitle" justify="center">
                លិខិតទទួលទំនិញ
            </v-row>
            <br>
            <hr style="border-top: 3px double">
            <table>
                <tr>
                    <td colspan="8">
                        លេខលិខិតបញ្ជាទិញ ៖ {{dataDoc.po_reference || ""}}
                    </td>
                </tr>
                <tr>
                    <td colspan="5">លេខលិខិតទទួលទំនិញ ៖ {{dataDoc.reference}}</td>
                    <td colspan="3">កាលបរិច្ឆេទ ៖ {{dataDoc.date}}</td>
                </tr>
                <tr>
                    <td colspan="8" class="fTitle3"><u><b>ដឹកចេញពី</b></u></td>
                </tr>
                <tr>
                    <td colspan="5">ឈ្មោះអ្នកផ្គត់ផ្គង់ ៖ {{dataDoc.supplier_name}}</td>
                    <td colspan="3">លេខទូរស័ព្ទ ៖ {{dataDoc.supplier_mobile | formatPhoneNumber}}</td>
                </tr>
                <tr>
                    <td colspan="3">អាស័យដ្ឋាន ៖ ផ្ទះលេខ {{dataDoc.supplier_home_no || ""}}</td>
                    <td colspan="3">ផ្លូវលេខ {{dataDoc.supplier_street_no || ""}}</td>
                    <td colspan="3">ភូមិ {{dataDoc.supplier_village_name || ""}}</td>
                </tr>
                <tr>
                    <td colspan="3">សង្កាត់/ឃុំ {{dataDoc.supplier_communce_name || ""}}</td>
                    <td colspan="3">ខណ្ឌ/ស្រុក {{dataDoc.supplier_district_name || ""}}</td>
                    <td colspan="3">រាជធានី/ខេត្ត {{dataDoc.supplier_province_name || ""}}</td>
                </tr>

                <tr>
                    <td colspan="8" class="fTitle3"><u><b>ដឹកជញ្ជូនទៅ</b></u></td>
                </tr>

                <tr>
                    <td colspan="4">ប៊ីដេប៉ូឈ្មោះ ៖ {{dataDoc.client_name}}</td>
                    <td colspan="4">លេខទូរស័ព្ទ ៖ {{ dataDoc.client_phone | formatPhoneNumber }}</td>
                </tr>
                <br>
                <tr>
                    <td colspan="2">អាសយដ្ឋាន៖ ភូមិ {{dataDoc.client_village_name || ""}}</td>
                    <td colspan="2">ឃុំ {{dataDoc.client_communce_name || ""}}</td>
                    <td colspan="2">ស្រុក {{dataDoc.client_district_name || ""}}</td>
                    <td colspan="2">ខេត្ត {{dataDoc.client_province_name || ""}}</td>
                </tr>
            </table>

            <table class="border">
                <thead>
                <tr>
                    <th>ល.រ</th>
                    <th>ឈ្មោះទំនិញ</th>
                    <th>ឯកតា</th>
                    <th>ចំនួន</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(d,i) in dataDoc.transaction_delivery_line" :key="i">
                    <td style="text-align: center">{{i+1}}</td>
                    <td>{{d.name}}</td>
                    <td style="text-align: center">{{d.unit_name}}</td>
                    <td>{{d.qty | formatNumber}}</td>
                </tr>
                <tr>
                    <th colspan="2" style="text-align: right">សរុប</th>
                    <td colspan="2" style="text-align: center">{{total | formatNumber}}</td>
                </tr>
                </tbody>
            </table>


            <table>
                <tr>
                    <td>ហត្ថលេខ/ស្នាមមេដៃអ្នកដឹកជញ្ជូន</td>
                    <td>ហត្ថលេខា/ស្នាមមេដៃអ្នកទទួល</td>
                </tr>
                <br><br>
                <tr>
                    <td colspan="2">ឈ្មោះ ៖ {{dataDoc.delivery_name}}</td>
                </tr>
                <tr>
                    <td>លេខទូរស័ព្ទ ៖ {{dataDoc.driver_phone}}</td>
                    <td style="text-align: right">ឈ្មោះ ៖ .................................................</td>
                </tr>
                <tr>
                    <td>កាលបរិច្ឆេទ ៖ .........................................</td>
                    <td style="text-align: right">កាលបរិច្ឆេទ ៖ .........................................</td>
                </tr>

            </table>
            <div class="footer-right">
                <p>Instant DN Form-V0 {{ today }}</p>
            </div>
        </div>


    </div>

</template>

<script>


    import {provider} from "@/service/provider";
    import axios from "axios";
    import moment from "moment";

    export default {
        data() {
            return {
                valid: false,
                loadingReport: false,
                params: {
                    dateRange: [],
                },
                today: moment().format("YYYYMMDD"),
                dataDoc: {},
                total:0

            }
        },
        methods: {
            handlePrint(event) {
                event.preventDefault();
                window.print();
            },
            handleRun(id, back) {
                let vm = this;
                vm.loadingReport = true;
                let url = provider.baseURL + provider.getTransactionDeliveryNote;
                return new Promise((resolve, reject) => {
                    axios.post(url, {
                        search: "",
                        id: id,
                        offset: 0,
                        type: "sale_order",
                        sort_by: "",
                        sort_desc: 0,
                        limit: 1,
                        contact_id: localStorage.contact_id,
                        status:  ""
                    }, {headers: {Authorization: localStorage.token}}).then(
                        res => {
                            if (res.data.response && res.data.response.code === 200) {
                                resolve(res.data.data);
                                let newItem = res.data.data[0];
                                vm.dataDoc = Object.assign({}, newItem);
                                vm.dataDoc.total_amount = parseFloat(vm.dataDoc.total_amount);
                                vm.total=0;
                                vm.dataDoc.transaction_delivery_line = vm.dataDoc.transaction_delivery_line.map((d) => {
                                    if (d && parseFloat(d.qty) > 0) {
                                        d.currency_code = vm.dataDoc.currency_code;
                                        d.qty = parseFloat(d.qty);
                                        d.price = parseFloat(d.price);
                                        d.total_amount = parseFloat(d.total_amount);
                                        vm.total+=d.qty;
                                        return d;
                                    }
                                })
                                vm.$nextTick(() => {
                                    window.print();
                                    vm.$router.push({name: back});
                                })
                            }
                        },
                        error => {
                            reject(error);
                        }
                    );
                })

            }
        },
        created() {
            let vm = this;
            let id = vm.$route.params.id;
            let back = vm.$route.params.back;
            if (id) {
                setTimeout(function () {
                    vm.handleRun(id, back);
                }, 300)
            }
        },
        watch: {},
    }
</script>